/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * PER_PERIOD (the default) means one entry buys one occurrence — a player enters Friday, and enters again for Saturday. ALL_PERIODS means one entry carries into every future occurrence; it is reserved for season-pass style boards and is not in use.
 * @export
 */
export const CompetitionEntryScope = {
    PER_PERIOD: 'PER_PERIOD',
    ALL_PERIODS: 'ALL_PERIODS'
} as const;
export type CompetitionEntryScope = typeof CompetitionEntryScope[keyof typeof CompetitionEntryScope];


export function instanceOfCompetitionEntryScope(value: any): boolean {
    for (const key in CompetitionEntryScope) {
        if (Object.prototype.hasOwnProperty.call(CompetitionEntryScope, key)) {
            if (CompetitionEntryScope[key as keyof typeof CompetitionEntryScope] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompetitionEntryScopeFromJSON(json: any): CompetitionEntryScope {
    return CompetitionEntryScopeFromJSONTyped(json, false);
}

export function CompetitionEntryScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionEntryScope {
    return json as CompetitionEntryScope;
}

export function CompetitionEntryScopeToJSON(value?: CompetitionEntryScope | null): any {
    return value as any;
}

export function CompetitionEntryScopeToJSONTyped(value: any, ignoreDiscriminator: boolean): CompetitionEntryScope {
    return value as CompetitionEntryScope;
}

